import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import CloseIcon from 'icons/close-icon.inline.svg';
import styles from './modal.module.scss';

const cx = classNames.bind(styles);

const Modal = ({ isOpen, onCloseButtonClick, children, ...props }) => (
  <ReactModal isOpen={isOpen} ariaHideApp={false} closeTimeoutMS={200} {...props}>
    <button className={cx('close')} type="button" onClick={onCloseButtonClick}>
      <CloseIcon />
    </button>
    {children}
  </ReactModal>
);

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseButtonClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Modal;
